import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmActionWithReviewsData } from '../cards-by-qr/cards-by-qr-rating/dialogs/confirm-action-with-reviews/confirm-action-with-reviews.component';

@Injectable({
  providedIn: 'root'
})
export class ReviewDialogDataService {

  constructor(private readonly translate: TranslateService) {}

  public getDeleteConfirmationData(): ConfirmActionWithReviewsData {
    return {
      title: this.translate.instant('rating.delete_review_popup.title'),
      description: this.translate.instant('rating.delete_review_popup.description'),
      actionButtonText: this.translate.instant('rating.delete_review_popup.actionButtonText'),
      cancelButtonText: this.translate.instant('rating.delete_review_popup.cancelButtonText')
    };
  }
}
